var map = {
	"./2023-06_service-to-the-state.png": "47cd",
	"./2023-08_experience-uga.png": "e63a",
	"./2023-09_academic-excellence.jpg": "6280",
	"./2023-11_research.jpg": "9bfc",
	"./2023-12_commencement.jpg": "4496",
	"./2023-12_powerhouse2.jpg": "58cf",
	"./2024-01_student-success.jpg": "92d1",
	"./2024-02_research-community.jpg": "d925",
	"./2024-04_experiential-learning.jpg": "c4df",
	"./career-readiness-cover.jpg": "953a",
	"./champions-poster.png": "fb4a",
	"./economic-impact.png": "cf33",
	"./placeholder-spring-commencement-23.jpg": "0ecf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa69";